var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("section", { staticClass: "invoice-details" }, [
    _c("header", { staticClass: "flex justify-between items-center mb-4" }, [
      _c("h2", { staticClass: "text-xl font-semibold m-0" }, [
        _vm._v("Invoice Details"),
      ]),
      _c(
        "button",
        {
          staticClass: "text-blue text-base hover:text-black",
          on: { click: _vm.onEdit },
        },
        [_vm._v(" Edit ")]
      ),
    ]),
    _c(
      "div",
      { staticClass: "details text-lg" },
      _vm._l(_vm.details, function (value, name) {
        return _c(
          "div",
          { key: name, staticClass: "detail flex justify-between py-2" },
          [
            _c(
              "span",
              {
                staticClass:
                  "block w-6/12 px-3 text-base font-normal text-gray-500",
              },
              [_vm._v(_vm._s(name))]
            ),
            _c(
              "span",
              {
                staticClass:
                  "block w-6/12 px-3 text-base font-medium text-black",
              },
              [_vm._v(_vm._s(value))]
            ),
          ]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }